// Tier Progress – Cart Drawer (49/69/100) – cohérent avec "Sous-total"

// 1) PALIERS EN CENTIMES
const tiers = [49, 69, 100].map(eur => eur * 100);

function clamp(n, min, max) {
  return Math.max(min, Math.min(max, n));
}

// 2) SOUS-TOTAL EN CENTIMES (Shopify Ajax cart)
async function getCartSubtotalCents() {
  const res = await fetch('/cart.js', { credentials: 'same-origin' });
  const cart = await res.json();
  return cart.items_subtotal_price; // ✅ cohérent avec "Sous-total"
}

function computeProgressPercent(subtotalCents) {
  const [t1, t2, t3] = tiers;

  // segments égaux : 0-33.33-66.66-100
  if (subtotalCents <= 0) return 0;

  if (subtotalCents < t1) {
    return clamp((subtotalCents / t1) * 33.333, 0, 33.333);
  }

  if (subtotalCents < t2) {
    return 33.333 + clamp(((subtotalCents - t1) / (t2 - t1)) * 33.333, 0, 33.333);
  }

  // t2 -> t3 (et au-dessus)
  return clamp(
    66.666 + ((subtotalCents - t2) / (t3 - t2)) * 33.333,
    66.666,
    100
  );
}

async function updateTierProgress() {
  const subtotalCents = await getCartSubtotalCents();
  const percent = computeProgressPercent(subtotalCents);

  // ✅ Mets ici le VRAI sélecteur du "fill"
  const bar = document.querySelector('.progress-fill');
  if (bar) bar.style.width = `${percent}%`;

  // (optionnel) marquer les paliers atteints si tu as des éléments .tp__item
  document.querySelectorAll('[data-threshold]').forEach(el => {
    const thr = parseFloat(el.dataset.threshold) * 100;
    el.classList.toggle('is-reached', subtotalCents >= thr);
  });

  console.log('[Tier] subtotal € =', (subtotalCents / 100).toFixed(2), 'progress % =', percent);
}

/* 1) init */
document.addEventListener('DOMContentLoaded', () => {
  updateTierProgress();
});

/* 2) observer DOM (car le drawer se re-render) */
const observer = new MutationObserver(() => {
  clearTimeout(window.__tierTimer);
  window.__tierTimer = setTimeout(updateTierProgress, 120);
});
observer.observe(document.body, { childList: true, subtree: true });

/* 3) hook fetch pour capter /cart/add /cart/change /cart/update */
(function hookFetch() {
  if (window.__tierFetchHooked) return;
  window.__tierFetchHooked = true;

  const origFetch = window.fetch;
  window.fetch = async (...args) => {
    const res = await origFetch(...args);

    try {
      const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
      const isCartCall =
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/clear');

      if (isCartCall) {
        setTimeout(updateTierProgress, 150);
      }
    } catch (e) {}

    return res;
  };
})();
